import * as Publishing from '@/services/legal-ad-form/components/amending/publishing';
import * as Company from '@/services/legal-ad-form/components/amending/company';
import { trimObject } from '@/shared/utils';

export default {
  id: 'additif',
  label: 'Additif',
  shortLabel: 'Additif',
  componentsData: {
    publishing: { text: `Il y a lieu d'ajouter ...` },
    company: {},
  },
  component: () => import('@/components/legal-ads/forms/models/amending/additive.vue'),
  validate(modelData) {
    return trimObject({
      publishing: Publishing.validate(modelData.publishing),
      company: Company.validate(modelData.company),
    });
  },
  buildContent(modelData) {
    return [
      Publishing.buildContent(modelData, 'ADDITIF'),
    ].flat().join("\n").replace(/undefined/g, '?');
  }
};